import { NumberInput, NumberInputProps } from "react-admin";

const CustomNumberInput = (props: NumberInputProps) => {
  return (
    <NumberInput
      label={false}
      onWheel={() => {
        if (document.activeElement instanceof HTMLElement) {
          document.activeElement.blur();
        }
      }}
      shouldUnregister={false}
      {...props}
    />
  );
};

export default CustomNumberInput;
